import React, { Component } from "react";
import Titulo from "../../../generico/TituloPagina";
import Popup from "react-popup";
import { mensajeExito } from "../../../generico/MensajeSistemaToast";
import HabilitarAhorroProgramadoService from "../../../../services/autogestion/HabilitarAhorroProgramadoService";
import ResumenServices from "../../../../services/resumenGeneral/resumenSocioService"
import { trackPromise } from "react-promise-tracker";
import { formatoSeparadorMilesValue } from "../../../generico/utils/FormatoInput";
import DatosSocio from "../../../generico/DatosSocio"
import AuthService from "../../../../services/login/auth.service";
import StepWizard from "react-step-wizard";
/*import Paso1 from "/TuMetaEsLaNuestraPaso1";
import Paso2 from "/TuMetaEsLaNuestraPaso2";
import Paso3 from "/TuMetaEsLaNuestraPaso3";*/
import Paso1 from "../../../pages/autogestion/tuMetaEsLaNuestra/TuMetaEsLaNuestraPaso1";
import Paso2 from "../../../pages/autogestion/tuMetaEsLaNuestra/TuMetaEsLaNuestraPaso2";
import Paso3 from "../../../pages/autogestion/tuMetaEsLaNuestra/TuMetaEsLaNuestraPaso3";

export default class TuMetaEsLaNuestra extends Component {
  /*constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.obtenerDatos = this.obtenerDatos.bind(this);
    this.obtenerListadoCuentasAhorro = this.obtenerListadoCuentasAhorro.bind(
      this
    );
  }*/
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.paso1 = React.createRef();
    this.paso2 = React.createRef();
    this.paso3 = React.createRef();

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.initData();
  }

  initData = () => {
    this.resetState();
    this.obtenerListadoCuentasAhorro();
  };

  resetState = () => {
    this.setState(this.getInitialState());
  };

  getInitialState = () => ({
    listaCuentas: [],
    cuentaOrigen: {},
    ctaFullData: {},
    plan: {},
    idAhorro:"",
    idMovimiento:"",
    monto:0,
    montoFinal:0,
    mostrarCalculo:false,
    fechaVencimiento:""
  });

  returnDataPaso1(_cuentaOrigen, _plan, _monto, _montoFinal,_nombre) {
    this.setState({
      cuentaOrigen: _cuentaOrigen,
      monto: _monto,
      plan: _plan,
      montoFinal: _montoFinal,
      nombre: _nombre
    });
  }

  returnDataPaso2(_cuenta_origen, _idAhorro, _fechaVencimiento,_idMovimiento) {
    this.setState({
      idAhorro: _idAhorro,
      fechaVencimiento: _fechaVencimiento,
      cuentaOrigen:_cuenta_origen,
      idMovimiento:_idMovimiento
    });
  }

  returnDataPaso3() {
    this.setState(this.getInitialState());
  }

  initDataChildren() {
    this.paso1.current.initData();
    this.paso3.current.resetState();
  }

  onStepChange = (stats) => {
    if (stats.previousStep === 2) {
      this.paso1.current.checkGrilla();
    }
  };

  obtenerListadoCuentasAhorro = () => {
    trackPromise(
        ResumenServices.getAHProgramadoSocio().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);

        if (jData.codigo === 0) {
          var items = jData.datos;
          for (var i = 0; i < items.length; i++) {
            respuesta.push({
              id: items[i].cuenta,
              cuenta: items[i].cuenta,
              saldo:
                formatoSeparadorMilesValue(items[i].saldoTotal) +
                " " +
                items[i].idMoneda +
                ".",
              //descripcion: items[i].descripcion,
            });
          }
        }
        this.setState({ listaCuentas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });
  };

  popupConfirmacion(tipoCuenta) {
    Popup.create({
      title: "Apertura de Cuenta",
      content:
        "¿Desea realizar la apertura de cuenta de ahorro programado en " + tipoCuenta+"?",
      buttons: {
        right: [
          {
            text: "Cancelar",
            className: "secundary",
            action: () => {  Popup.close(); }
          },
          {
            text: "Aceptar",
            className: "success",
            action: () => {
              var idMoneda = tipoCuenta === "Dólares" ? "U$S" : "GS";
              //console.log(idMoneda);
              trackPromise(
                HabilitarAhorroProgramadoService.aperturaCuentaAhorro(idMoneda).then(
                  (response) => {
                    var data = JSON.stringify(response.data);
                    var jData = JSON.parse(data);
                    //console.log(jData);
                    if (jData.codigo === 0) {
                      mensajeExito(
                        "La Cuenta Nro. " +
                          jData.datos.idAhorro +
                          " fue Habilitada"
                      );
                      Popup.close();
                      Popup.queue(
                        this.notifiPopupDescargarComprobante(
                          "Comprobante",
                          "Cuenta Nro. " +jData.datos.idAhorro,
                          jData.datos,
                          jData.datos.idAhorro,
                          idMoneda
                        )
                      );
                      this.obtenerListadoCuentasAhorro();
                    } else {
                     
                      Popup.close();
                      Popup.queue(this.notifiPopup("Error", jData.mensaje));
                    }
                  }
                )
              );
            },
          }
        ],
      },
    });
  }

  notifiPopupDescargarComprobante = (titulo, mensaje, nroOperacion, cuenta, moneda) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Bajar PDF",
            className: "success",
            action: function () {
                HabilitarAhorroProgramadoService.descagarComprobante(
                "APERTURA DE CAJA DE AHORRO",
                nroOperacion,
                AuthService.getSocio().nombreCompleto,
                AuthService.getSocio().numeroSocio, 
                cuenta, 
                "INDIVIDUAL",
                "A LA VISTA",
                moneda
              )
              .then((response) => {
                var fileURL = URL.createObjectURL(response.data);
                window.open(fileURL, "");         
              })
              .catch(function (error) {
                console.log(error);
              })
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerColumas() {
    return [
      {
        name: "Cuenta",
        selector: "cuenta",
      },
      {
        name: "Descripción",
        selector: "descripcion",
      },
      {
        name: "Saldo",
        selector: "saldo",
        right: true,
      },
    ];
  }

  obtenerDatos() {
    const { listaCuentas } = this.state;
    return listaCuentas;
  }

  render() {
    return (
      <div className="content-wrapper">
        <Titulo texto="Tu Meta es la Nuestra" />
       
        <section className="content">
          <div className="container">
          <h6 className="sub-title-meta">Habilitar Ahorro Programado</h6>
            <div className="row justify-content-md-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio/> 
                  </div>
                  <div className="card-body">
                  <StepWizard
                      onStepChange={this.onStepChange}
                      transitions="none"
                    >
                      <Paso1
                        ref={this.paso1}
                        returnDataPaso1={this.returnDataPaso1.bind(this)}
                      />
                      <Paso2
                        ref={this.paso2}
                        returnDataPaso2={this.returnDataPaso2.bind(this)}
                        cuentaOrigen={this.state.cuentaOrigen}
                        plan={this.state.plan}
                        monto={this.state.monto}
                        montoFinal={this.state.montoFinal}
                        nombre={this.state.nombre}
                        idMovimiento={this.state.idMovimiento}
                      />
                      <Paso3
                        ref={this.paso3}
                        returnDataPaso3={this.returnDataPaso3.bind(this)}
                        cuentaOrigen={this.state.cuentaOrigen}
                        plan={this.state.plan}
                        monto={this.state.monto}
                        montoFinal={this.state.montoFinal}
                        idAhorro={this.state.idAhorro}
                        fechaVencimiento={this.state.fechaVencimiento}
                        idMovimiento={this.state.idMovimiento}
                      />
                  </StepWizard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
